<template>
    <div id="projectListContainer">
        <transition appear name="appear">
            <div id="projectList" :class="getCategory" v-if="render">
                <template v-if="$route.name == 'project-list-typefaces'">
                    <div class="column">
                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'freiburg' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-03.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-04.svg"
                                />
                                <div class="projectTitle">
                                    Custom Typeface for Theater Freiburg
                                </div>
                            </router-link>
                        </div>

                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'tdtwt' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-01.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-02.svg"
                                />
                                <div class="projectTitle">
                                    Custom Typeface for London Performance
                                    Company TDTWT
                                </div>
                            </router-link>
                        </div>

                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'bill' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-11.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-12.svg"
                                />
                                <div class="projectTitle">
                                    Retail Typeface in 2 Cuts
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="column">
                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'kvhbf' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-05.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-06.svg"
                                />
                                <div class="projectTitle">
                                    Custom Typeface for Kunstverein Harburger
                                    Bahnhof
                                </div>
                            </router-link>
                        </div>

                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'neue-jahn-antiqua' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-07.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-08.svg"
                                />
                                <div class="projectTitle">
                                    Custom Typeface for Jahn und Jahn Munich and
                                    Lissabon
                                </div>
                            </router-link>
                        </div>
                        <div class="project typefaceProject">
                            <router-link
                                :to="{
                                    name: 'project-detail',
                                    params: { slug: 'montez-grotesque' }
                                }"
                            >
                                <img
                                    class="regularImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-09.svg"
                                />
                                <img
                                    class="hoverImage"
                                    src="../assets/svg/JMMP_Website_Projects_Typefaces_03_JM-10.svg"
                                />
                                <div class="projectTitle">
                                    Custom Typeface for Montez Press and Montez
                                    Press Radio
                                </div>
                            </router-link>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div v-for="project in getProjects" class="project">
                        <router-link
                            v-if="project.preview_image"
                            :to="{
                                name: 'project-detail',
                                params: { slug: project.slug }
                            }"
                        >
                            <img :src="project.preview_image" />
                            <div class="projectTitle">{{ project.title }}</div>
                        </router-link>
                    </div>
                </template>
            </div>
        </transition>
        <transition appear name="appear">
            <div id="spinner" v-if="!render">
                <div class="lds-spinner" v-if="!render">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { store } from "@/centralStore";
export default {
    name: "ProjectList",
    data() {
        return {
            store: store.state,
            render: false
        };
    },
    computed: {
        getCategory() {
            if (this.$route.name == "project-list-books") {
                return ["Book", "Periodical", "Magazine"];
            } else if (this.$route.name == "project-list-websites") {
                return ["Website"];
            } else if (this.$route.name == "project-list-typefaces") {
                return ["Typeface (Project)"];
            } else if (this.$route.name == "project-list-identities") {
                return ["Visual Identity (Project)"];
            }
        },
        getProjects() {
            let filtered = this.store.allProjects.filter(
                p =>
                    this.getCategory.includes(p.category.name) &&
                    !!p.preview_image
            );
            let sorted = filtered.sort(function(a, b) {
                return a.end_year > b.end_year
                    ? -1
                    : a.end_year < b.end_year
                    ? 1
                    : 0;
            });
            return sorted;
        }
    },
    activated() {
        this.store.lastProject = this.$route.name;
    },
    updated() {
        this.store.lastProject = this.$route.name;
    },
    methods: {
        waitForImages() {
            const imageElements = this.getProjects.map(p => p.preview_image);

            const promises = imageElements.map(src => {
                return new Promise(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            });

            Promise.all(promises).then(() => {
                const myself = this;
                setTimeout(function() {
                    myself.render = true;
                }, 200);
            });
        }
    },
    mounted() {
        const myself = this;
        this.store.lastProject = this.$route.name;
        setTimeout(function() {
            myself.waitForImages();
        }, 200);
    }
};
</script>
<style scoped>
@font-face {
    font-family: "TDTWT";
    src: url("../assets/typefaces/TDTWT/TDTWTVF.ttf");
    font-weight: 38 85;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: "Montez Grotesque Display";
    src: url("../assets/typefaces/MontezGrotesque/MontezGrotesque-Display.otf");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: "Montez Grotesque";
    src: url("../assets/typefaces/MontezGrotesque/MontezGrotesque2-04VF.ttf");
    font-weight: 60 164;
    font-display: swap;
}

@font-face {
    font-family: "Neue Jahn Regular";
    src: url("../assets/typefaces/NeueJahn/NeueJahnAntiqua2-03-Regular.otf");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: "Neue Jahn Regular Italic";
    src: url("../assets/typefaces/NeueJahn/NeueJahnAntiqua2-03-RegularItalic.otf");
    font-weight: normal;
    font-style: italic;
    font-display: block;
}

@font-face {
    font-family: "KvHBF Sud Regular";
    src: url("../assets/typefaces/KvHBF/Arena_0-24-KvHbfSudRegular.otf");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: "Freiburg";
    src: url("../assets/typefaces/FreiburgVariable/FreiburgVF.ttf");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}
#projectListContainer {
    padding-bottom: 2em;
}

#projectList {
    margin: 0 1rem;
    gap: 8px;
}
@media screen and (min-width: 768px) {
    #projectList {
        gap: 1rem;
    }
}
#projectList img {
    display: block;
}
#projectList.Book {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
}
#projectList.Book .projectTitle {
    display: none;
}
#projectList.Book img {
    height: 29vw;
}

@media screen and (min-width: 768px) {
    #projectList.Book img {
        height: 300px;
    }
}
#projectList.Website {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(500px, 100%), 1fr));
    gap: 2rem 1rem;
}

#projectList.Website .project {
    /* aspect-ratio: 4 / 3.1; */
    /* max-width: calc(100vw - 2em); */
}
#projectList.Website img {
    max-height: 100%;
    width: 100%;
}
#projectList.Identity {
    display: grid;
    gap: 2rem 1rem;
    grid-template-columns: 1fr;
}
#projectList.Typeface {
    display: flex;
    flex-direction: column;
    gap: 2rem 1rem;
}
#projectList.Typeface .column {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2rem 1rem;
    min-height: 0;
}
#projectList.Typeface .project {
    min-height: 0;
}
#projectList.Typeface .project img {
    display: block;
    min-height: 0;
    max-width: 100%;
    height: auto;
}

#projectList.Identity img {
    max-height: 100%;
    width: 100%;
}
@media screen and (min-width: 768px) {
    #projectList.Identity {
        grid-template-columns: 1fr 1fr;
    }
    #projectList.Typeface {
        flex-direction: row;
    }
}
.projectTitle {
    color: #969696;
    /* text-align: center; */
}
@media screen and (min-width: 768px) {
    .project:hover .projectTitle {
        color: white;
    }
}
.project > a {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    color: white;
    text-decoration: none;
}
.slide-container {
    width: 100%;
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;
}
@media screen and (min-width: 768px) {
    .slide-container {
        grid-template-columns: 1fr 1fr;
    }
}
.slide-container > a {
    color: white;
    text-decoration: none;
}

.title-slide-rahmen {
    container-type: inline-size;
    width: 100%;
    aspect-ratio: 4 / 3;
    background-color: black;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    border: 1px solid #565656;
    cursor: pointer;
}

/* TDTWT Start */

.title-slide-rahmen .title-tdtwt {
    font-size: 28cqw;
    line-height: 1;
    font-family: "TDTWT";
    font-variation-settings: "wght" 62, "SIZE" 1000;
    font-feature-settings: "calt" 0, "ss07" 1;
}

.title-slide-rahmen .title-tdtwt span {
    transition: 0.5s ease;
}

/* TDTWT Zustand 1 */

.t-1 {
    font-variation-settings: "wght" 62, "SIZE" 0;
}
.d {
    font-variation-settings: "wght" 62, "SIZE" 1000;
}
.t-2 {
    font-variation-settings: "wght" 62, "SIZE" 750;
}
.w {
    font-variation-settings: "wght" 62, "SIZE" 0;
}
.t-3 {
    font-variation-settings: "wght" 62, "SIZE" 750;
}

/* TDTWT Zustand 2 */
.title-slide-rahmen:hover .title-tdtwt .t-1 {
    font-variation-settings: "wght" 62, "SIZE" 1000;
}
.title-slide-rahmen:hover .title-tdtwt .d {
    font-variation-settings: "wght" 62, "SIZE" 0;
}
.title-slide-rahmen:hover .title-tdtwt .t-2 {
    font-variation-settings: "wght" 62, "SIZE" 750;
}
.title-slide-rahmen:hover .title-tdtwt .w {
    font-variation-settings: "wght" 62, "SIZE" 1000;
}
.title-slide-rahmen:hover .title-tdtwt .t-3 {
    font-variation-settings: "wght" 62, "SIZE" 0;
}

/* TDTWT Ende */

/* Montez Grotesque Start */

.title-slide-rahmen .title-montez {
    font-size: 17cqw;
    line-height: 1;
    font-family: "Montez Grotesque";
    padding-bottom: 1cqw;
    font-variation-settings: "wght" 164, "ital" 0;
    transition: 0.5s;
}

.title-slide-rahmen:hover .title-montez {
    font-variation-settings: "wght" 60, "ital" 100;
}

/* Montez Grotesque Ende */

/* Neue Jahn Antiqua Start */

.title-slide-rahmen .title-neue-jahn {
    font-size: 16cqw;
    line-height: 1;
    font-family: "Neue Jahn Regular";
    padding-bottom: 2cqw;
}

.title-slide-rahmen:hover .title-neue-jahn {
    display: none;
}

.title-slide-rahmen:hover .title-neue-jahn.jahn-antiqua-regular-italic {
    display: block;
}

.jahn-antiqua-regular-italic {
    display: none;
}

.italic {
    font-family: "Neue Jahn Regular Italic";
}

/* Neue Jahn Antiqua Ende */

/* KvHBF Start */

.title-slide-rahmen .title-kvhbf {
    font-size: 24cqw;
    line-height: 1;
    font-family: "KvHBF Sud Regular";
    padding-bottom: 2cqw;
}

.title-slide-rahmen:hover .title-kvhbf {
    font-feature-settings: "ss01" 1, "ss04" 1;
}

/* KvHBF Ende */

/* Freiburg Start */

.title-slide-rahmen .title-freiburg {
    font-size: 18cqw;
    line-height: 1;
    font-family: "Freiburg";
    font-variation-settings: "YTDE" 224, "wdth" 500, "INKT" 0;
    transition: 0.5s;
    padding-bottom: 0cqw;
    transform-origin: center;
}

.title-slide-rahmen:hover .title-freiburg {
    font-variation-settings: "YTDE" 91, "wdth" 500, "INKT" 1000;
    transform: scaleY(4);
}

/* Freiburg Ende */
.lds-spinner {
    color: official;
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    transform: scale(0.5);
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
#projectList .typefaceProject img {
    border: 0.5px solid #565656;
    display: block;
    width: 100%;
    height: auto;
}
#projectList .typefaceProject img.hoverImage {
    display: none;
}
#projectList .typefaceProject:hover img.regularImage {
    display: none;
}
#projectList .typefaceProject:hover img.hoverImage {
    display: block;
}
</style>
